import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="search"
export default class extends Controller {
  connect() {
    this.element.addEventListener('search', this.handleSearch.bind(this))
  }

  handleSearch(event) {
    if (this.element.value === '') {
      const url = new URL(this.element.form.action, window.location.origin)
      window.location.href = url.pathname
    }
  }
}
